// ============================================================================
// MASTER CODE SERVICE — prefix and digit width of the automatic customer / service codes.
// ============================================================================

import { get, put } from '../client/axiosClient';
import { masterCodeEndpoints } from '../endpoints/commercial.endpoints';
import type { ApiResponse, MasterCodeSeriesDto, UpdateMasterCodeSeriesRequest } from '../types';

class MasterCodeService {
  /** Every code series of the entity (defaults filled in for series never used). */
  async getSeries(): Promise<MasterCodeSeriesDto[]> {
    const response = await get<ApiResponse<MasterCodeSeriesDto[]>>(masterCodeEndpoints.series());
    return response.data.data;
  }

  /** Save the prefix and digit width of one series. The serial is never changed by a save. */
  async saveSeries(seriesKey: string, data: UpdateMasterCodeSeriesRequest): Promise<MasterCodeSeriesDto> {
    const response = await put<ApiResponse<MasterCodeSeriesDto>>(masterCodeEndpoints.saveSeries(seriesKey), data);
    return response.data.data;
  }
}

export const masterCodeService = new MasterCodeService();
export default masterCodeService;
